import { render, staticRenderFns } from "./addSupplierDialog.vue?vue&type=template&id=15c39e28&scoped=true"
import script from "./addSupplierDialog.vue?vue&type=script&lang=js"
export * from "./addSupplierDialog.vue?vue&type=script&lang=js"
import style0 from "./addSupplierDialog.vue?vue&type=style&index=0&id=15c39e28&prod&lang=scss"
import style1 from "./addSupplierDialog.vue?vue&type=style&index=1&id=15c39e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c39e28",
  null
  
)

export default component.exports